export function SortArrowUpSvg() {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         width="13"
         height="13"
         viewBox="0 0 10 13"
         fill="none"
      >
         <path
            d="M6.60583 9.01498C6.89683 9.30948 6.89433 9.78448 6.59983 10.0755L4.70333 11.9505C4.46133 12.192 4.14283 12.3135 3.82383 12.3135C3.50483 12.3135 3.18283 12.192 2.93883 11.948L1.04533 10.076C0.750828 9.78498 0.748328 9.30998 1.03933 9.01548C1.33033 8.72048 1.80583 8.71848 2.10033 9.00948L3.07283 9.97098V1.04248C3.07283 0.62848 3.40833 0.29248 3.82283 0.29248C4.23733 0.29248 4.57283 0.62848 4.57283 1.04248V9.97098L5.54533 9.00948C5.84033 8.71848 6.31483 8.72048 6.60633 9.01548L6.60583 9.01498Z"
            fill="white"
         />
      </svg>
   )
}
